import { snapshot } from 'valtio';
import { calcDateRange } from '../../app/store-actions/top-bar-store-actions';
import TopBarStore from '../../app/stores/top-bar-store';
import scanHistoryService from '../services';
import { setScanHistoryData } from '../stores/scan-history-store-actions';
import { formatScanHistoryData } from '../utils/scan-history-utils';

export const fetchScanHistoryData = async () => {
  const { dateRange } = snapshot(TopBarStore);
  const [from, to] = calcDateRange(dateRange);
  const response = await scanHistoryService.getScanHistoryData.execute({
    limit: 100,
    dateRange: { from, to },
  });
  if (response) {
    setScanHistoryData(response);
    formatScanHistoryData(response);
  }
};
